import React from 'react';
import { ArrowUpRightIcon } from 'lucide-react';
import { clientSites } from '../data/projects';
import { SectionHeading } from './SectionHeading';
export function ClientWork() {
  return <section id="clientes" className="border-b border-hairline py-24 lg:py-32" data-id="element-13" data-mp="1csukhk5edivo">
      <div className="mx-auto max-w-6xl px-6" data-id="element-14" data-mp="18rj0pv97frve">
        <div className="grid gap-12 lg:grid-cols-[minmax(0,380px)_minmax(0,1fr)] lg:items-start" data-id="element-15" data-mp="18sk9tu6nu4ah">
          <SectionHeading index="05 — Clientes" title="Trabajo por encargo" description="Sitios para negocios y profesionales de la zona. Mismo criterio que el resto: código propio, repositorio abierto y nada que el cliente no pueda mantener." data-id="element-16" data-mp="l2zox5qy4wyk" />

          <ul className="divide-y divide-hairline border-y border-hairline" data-id="element-17" data-mp="p2gyobdeog9j">
            {clientSites.map(site => <li key={site.name} data-id="element-18" data-mp="1ceaw7gixwgq">
                <a href={site.repo} target="_blank" rel="noreferrer" className="group flex items-center justify-between gap-6 py-5 transition-colors duration-150 ease-out hover:bg-panel focus:outline-none focus-visible:ring-2 focus-visible:ring-teal" data-id="element-19" data-mp="3thq7wttg97qq">
                  <div className="pl-1" data-id="element-20" data-mp="3s8gq63pqbe6t">
                    <h3 className="font-mono text-lg text-ink-hi transition-colors duration-150 ease-out group-hover:text-teal" data-id="element-21" data-mp="3s9i9evgwf6zm">
                      {site.name}
                    </h3>
                    <p className="mt-1 text-[15px] text-ink-mid" data-id="element-22" data-mp="2zkkt2xw8zk9i">{site.detail}</p>
                  </div>
                  <ArrowUpRightIcon className="h-5 w-5 shrink-0 text-ink-mid transition-transform duration-150 ease-out group-hover:-translate-y-0.5 group-hover:text-teal" aria-hidden="true" data-id="element-23" data-mp="34jxgbjr16tcm" />
                </a>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}